/*
 * Copyright (c) 2018 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';
import LanguageService from '@/services/language';

/**
 * Language route guard.
 *
 * Detects a given language and sets the Vuex state accordingly.
 *
 * @param to
 * @param from
 * @param next
 */
export const languageGuard: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    if (to.query && to.query.lang) {
        LanguageService.updateLanguage(to.query.lang);
    }

    next();
};
